import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';

import { ViewChild, ElementRef } from '@angular/core';
import Cropper from 'cropperjs';
import { UserData, LinkData } from '../../Models/Authentication/UserModel';
import { User } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { ImageUploadService } from '../../Services/image-upload.service';
import { OperationMessageService } from '../../Services/operation-message.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-linktree-setting',
  templateUrl: './linktree-setting.component.html',
  styleUrls: ['./linktree-setting.component.css'],standalone:false
})
export class LinktreeSettingComponent extends BaseComponent implements OnInit {
  @ViewChild('imageElement', { static: false }) imageElement!: ElementRef<HTMLImageElement>;
  @ViewChild('myModal', { static: false }) modalElement!: ElementRef;
  cropper!: Cropper;
  imageUrl: string | ArrayBuffer | null = null;
  croppedImage: string | null = null;
  user!:User
  user1!:UserData
  userId:string;
  form!: FormGroup;
  Links!: FormGroup;
  MailForm!: FormGroup;
  //imageUrl: string = '../../../assets/images/Linktree/templates/DumyUser.png';
  loading:boolean=false;
  userRole:string='';
  linksData:LinkData[]=[]
  socialLink:LinkData[]=[]
  showUpdate:boolean=false
  mess:string=''
  socialMediaPlatforms = [
    { name: 'Facebook', icon: 'fab fa-facebook-square' },
    { name: 'Instagram', icon: 'fab fa-instagram' },
    { name: 'Twitter', icon: 'fab fa-twitter' },
    { name: 'LinkedIn', icon: 'fab fa-linkedin' },
    { name: 'YouTube', icon: 'fab fa-youtube' },
    { name: 'Snapchat', icon: 'fab fa-snapchat' },
    { name: 'WhatsApp', icon: 'fab fa-whatsapp' },
    { name: 'TikTok', icon: 'fab fa-tiktok' },
    { name: 'Pinterest', icon: 'fab fa-pinterest' },
    { name: 'Reddit', icon: 'fab fa-reddit' },
    { name: 'Tumblr', icon: 'fab fa-tumblr' },
    { name: 'WeChat', icon: 'fab fa-weixin' },
    { name: 'Thread', icon: 'fas fa-comment-alt' },
    { name: 'Apple App Store', icon: 'fab fa-app-store-ios' },
    { name: 'Apple Music', icon: 'fab fa-itunes-note' },
    { name: 'Amazon', icon: 'fab fa-amazon' },
    { name: 'Google', icon: 'fab fa-google' },
    { name: 'Google Meet', icon: 'fab fa-google-plus-g' },
    { name: 'Apple Podcast', icon: 'fab fa-itunes' },
    { name: 'App', icon: 'fas fa-mobile-alt' },
    { name: 'BeReal', icon: 'fas fa-smile' },
    { name: 'Bandcamp', icon: 'fab fa-bandcamp' },
    { name: 'Bluesky', icon: 'fas fa-cloud' },
    { name: 'Cameo', icon: 'fas fa-camera' },
    { name: 'Clubhouse', icon: 'fas fa-house-user' },
    { name: 'Etsy', icon: 'fab fa-etsy' },
    { name: 'LinkedIn', icon: 'fab fa-linkedin' },
    { name: 'GitHub', icon: 'fab fa-github' },
    { name: 'Patreon', icon: 'fab fa-patreon' },
    { name: 'Mastodon', icon: 'fab fa-mastodon' },
    { name: 'Kick', icon: 'fas fa-boot' },
    { name: 'Poshmark', icon: 'fa-regular fa-hourglass' },
    { name: 'SoundCloud', icon: 'fab fa-soundcloud' },
    { name: 'Spotify', icon: 'fab fa-spotify' },
    { name: 'Substack', icon: 'fas fa-newspaper' },
    { name: 'Telegram', icon: 'fab fa-telegram' },
    { name: 'Signal', icon: 'fa-regular fa-comment' },
    { name: 'Twitch', icon: 'fab fa-twitch' }
  ];
  loadImg:boolean=false;
  constructor
    (

      private auth: AuthService,
      private messageService: MessageService,
      private fb: FormBuilder,
      private api: BaseApiService,
      private imageUploadService: ImageUploadService,
      private translate: OperationMessageService,

    ) {
    super()
    this.userId = this.auth.getUID();
    this.userRole = this.auth.getRoles().toString();

  }










  getdata(uid:any){
    this.loading=true;
    this.api.read(`Auth/getProfile?uid=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
          next:(response)=>{
            this.user = response;
            if(this.user!=null){
              this.form.patchValue(this.user)
              this.loading=false;
            }
            this.loading=false;
          },
          error:(
            error
          )=>{
    
            this.loading=false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
          }
      }
    
    )
  }

  singleLink(link:LinkData)
  {
     this.showUpdate=true;
     this.Links.patchValue(link);
  }


  GetAll(uid:any){
   this.loading=true;
   this.api.read(`Auth/getByIdDT?uid=${uid}`).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
   ).subscribe
   (
      {
        next:(response)=>{
          this.user1 = response;
          this.loading=false;
        },
        error:(
          error
        )=>{
   
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
        }
      }
    )
  }

  selectPlatform(platform: any)
  {
    this.Links.get('linkType')?.setValue(platform);
    this.mess=platform;
  }
  GetAllLinks(uid:any){
    this.loading=true;
    this.api.read(`SocialLinks/UserLinks?userid=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.linksData = response;
          this.loading   = false;
          this.loadImg   = false;
        },
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage()});
        }
      }
      
    )
   }


   GetSocilaLinks(uid:any){
    this.loading=true;
    this.api.read(`SocialLinks/SocilaLinks?userid=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
   .subscribe
    (
      
       {
          next:(response)=>{
            this.socialLink = response;
            this.loading    =false;
          },
          error:(
            error
          )=>{
    
            this.loading=false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
          }
       }

    )
   }


  initilizeForm(){
    this.loading=true;
    this.form = this.fb.group({
      id: [''],
      title: [''],
      description: [''],
      image:  [this.imageUrl],
      userid: [this.userId],
    });
    this.loading=false;
  }

  initilizeFormLink(){
    this.loading =true;
    this.Links   = this.fb.group
    ({
      id: [''],
      userId: [this.userId],
      linkType: [''],
      link: ['',Validators.required],
      linkIcon:  ['Social'],
    });
    this.loading=false;
  }

  initilizeMail(){
    this.loading =true;
    this.MailForm   = this.fb.group
    ({
      id    : [this.userId],
      email :  ['',[Validators.required, Validators.email]],
    });
    this.loading=false;
  }
  ngOnInit(): void {
    this.initilizeMail();
    this.initilizeFormLink();
    this.initilizeForm()
    this.GetSocilaLinks(this.userId);
    this.GetAllLinks(this.userId);
    this.GetAll(this.userId);
    this.getdata(this.userId);

  }

  onSubmit(): void {
    this.loading = true;
    this.loadImg=true
    this.api.update("Auth/UpdateProfile", this.form.value).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
        this.loadImg = false;
      })

    ).subscribe
      (
         {
           next: (response) => {
            this.getdata(this.userId);
            this.GetAll(this.userId);
            this.GetAllLinks(this.userId);
  
            this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.GetSuccessMessage() });
            this.loading = false;
  
          },
          error:(
            error
          ) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
          }

         }
      )
  }


  AddEmail(): void {
    this.loading = true;
    this.api.update("Auth/AddBossEmail", this.MailForm.value)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
      ( 
        {
           next: (response) => {
            this.getdata(this.userId);
            this.GetAll(this.userId);
            this.GetAllLinks(this.userId);
            this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.GetErrorMessage() });
            this.loading = false;
          },
          error:(
            error
          ) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
          }
        }

      )
  }

  onSubmitLinks(): void {
    this.loading     = true;
    const dataToSend = { ...this.Links.value };
    delete dataToSend.id;
    this.api.create("SocialLinks", dataToSend)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      }
    )
    )
    .subscribe
      (
        {
          next:(response) =>
            {
              this.getdata(this.userId);
              this.GetAll(this.userId);
              this.GetSocilaLinks(this.userId);
              this.GetAllLinks(this.userId);
              this.Links.reset()
              this.initilizeForm();
              this.initilizeFormLink();
              this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.GetSuccessMessage()});
              this.loading = false;
            },
            error:(
              error
            ) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
            }
        }
        
      )
  }

  onDelete(id:any): void {
    this.loading = true;
    this.api.delete(`SocialLinks?id=${id}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
      (

        {
          next:(response) =>
            {
              this.getdata(this.userId);
              this.GetAll(this.userId);
              this.GetSocilaLinks(this.userId);
              this.GetAllLinks(this.userId);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.GetSuccessMessage() });
              this.loading = false;
            },
            error:(
              error
            ) => {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
            }
        }
      )
  }
  onUpdate(): void {
    this.loading = true;
    const dataToSend = { ...this.Links.value };
    this.api.update("SocialLinks", dataToSend)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      } )
    )
    .subscribe
      (
        (response) =>
        {
          this.getdata(this.userId);
          this.GetAll(this.userId);
          this.GetSocilaLinks(this.userId);
          this.GetAllLinks(this.userId);
          this.showUpdate=false;
          this.Links.reset()
          this.initilizeForm();
          this.initilizeFormLink();
          this.messageService.add({ severity: 'success', summary: 'Success', detail: this.translate.GetSuccessMessage() });
          this.loading = false;
        }
        , (
          error
        ) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.translate.GetErrorMessage() });
        }
      )
  }



onFileChange(event: Event): void {

  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageUrl = e.target?.result ?? null;
      if (this.cropper) {
        this.cropper.destroy();
      }
      setTimeout(() => {
        this.initializeCropper();
      }, 0);
    };
    reader.readAsDataURL(file);
  }
}

initializeCropper(): void {
  const image = this.imageElement.nativeElement;
  this.cropper = new Cropper(image, {
    aspectRatio: 4 / 3, // Adjust the aspect ratio as needed
    viewMode: 1,
    autoCropArea: 1,
    responsive: true,
    movable: true,
    zoomable: true,
    rotatable: false,
    scalable: false,
    cropBoxResizable: false,
    ready: () => {
      const cropper = this.cropper;
      cropper.setCropBoxData({
        width: 250, // Set your desired width
        height: 250 // Set your desired height
      });
    },

  });
}






cropImage(): void {

  if (this.cropper) {
    const canvas = this.cropper.getCroppedCanvas({
      width: 250,
      height: 250
    });
    this.croppedImage = canvas.toDataURL('image/png');

    this.uploadCroppedImage(this.croppedImage);

  }
}

dataURItoBlob1(dataURI: string): Blob {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

uploadCroppedImage(dataUrl: string): void {
  this.loading = true;
  const blob = this.dataURItoBlob1(dataUrl);
  const file = new File([blob], 'cropped_image.png', { type: 'image/png' });

  this.imageUploadService.uploadImage(file).subscribe(
    (imageUrl: string) => {
      this.imageUrl = imageUrl;
      this.form.get('image')?.setValue(imageUrl);
      this.onSubmit();
      this.loading = false;
    },
    (error) => {
      this.loading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
    }
  );
}



closeModal() {
  this.modalElement.nativeElement.classList.remove('show');
  document.body.classList.remove('modal-open');
  document.body.classList.add('hide');
}



}
